import React, { useState } from 'react';
import './ToolPage.css';

const JsonFormatter = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [error, setError] = useState('');
  const [indentSize, setIndentSize] = useState(2);

  const formatJson = () => {
    try {
      const parsed = JSON.parse(input);
      setOutput(JSON.stringify(parsed, null, indentSize));
      setError('');
    } catch (e) {
      setError(`Invalid JSON: ${e.message}`);
      setOutput('');
    }
  };

  const minifyJson = () => {
    try {
      const parsed = JSON.parse(input);
      setOutput(JSON.stringify(parsed));
      setError('');
    } catch (e) {
      setError(`Invalid JSON: ${e.message}`);
      setOutput('');
    }
  };

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
  };

  const clearAll = () => {
    setInput('');
    setOutput('');
    setError('');
  };

  return (
    <div className="tool-page">
      <div className="tool-header">
        <h1 className="tool-title">JSON Formatter</h1>
        <p className="tool-description">
          Format, validate, and beautify JSON data
        </p>
      </div>

      <div className="tool-content">
        <div className="textarea-row">
          <div className="textarea-group">
            <label className="input-label">Input JSON</label>
            <textarea
              className="textarea-field"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder='{"key": "value"}'
              rows={12}
            />
          </div>

          <div className="textarea-group">
            <label className="input-label">Output</label>
            <textarea
              className="textarea-field"
              value={output}
              readOnly
              placeholder="Formatted JSON will appear here"
              rows={12}
            />
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="button-row">
          <div className="indent-control">
            <label className="input-label">Indent:</label>
            <select
              className="select-field"
              value={indentSize}
              onChange={(e) => setIndentSize(Number(e.target.value))}
            >
              <option value={2}>2 spaces</option>
              <option value={4}>4 spaces</option>
              <option value={8}>8 spaces</option>
            </select>
          </div>
          <button className="action-btn primary" onClick={formatJson}>
            Format
          </button>
          <button className="action-btn" onClick={minifyJson}>
            Minify
          </button>
          <button className="action-btn" onClick={copyOutput} disabled={!output}>
            Copy Output
          </button>
          <button className="clear-btn" onClick={clearAll}>
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default JsonFormatter;
